import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import main from '@/utils/main';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import './quasar';
import './style/media.less';
import './style/website.less';
import './style/artical.less';

Vue.use(VueAwesomeSwiper);

router.beforeEach((to, form, next) => {
    if (main.getUA().isMobile) {
        const { name } = to;
        const fullPath = document.location.pathname + document.location.search + document.location.hash;
        if (/^\/website/.test(fullPath) || name === 'root') {
            const wapPath = fullPath.replace(/^\/website/, '/wap');
            const nextPath = name === 'root' ? '/wap' : wapPath;
            document.location.replace(nextPath);
            next(false);
        } else {
            next();
        }
    } else {
        const navigatePos = window.localStorage.getItem('ZBHA_NAV_POS') || '';
        window.history.replaceState({ navigatePos }, null, null);
        next();
    }
});
router.afterEach((to, form) => {
    window.scrollTo(0, 0);
    if (window._czc) {
        const content_url = to.fullPath;
        const referer_url = form.path;
        window._czc.push(['_trackPageview', content_url, referer_url]);
    }
});
const unsync = sync(store, router);
unsync();


Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');

export { store, router };
